export default __webpack_public_path__ + "static/media/cp_geo_mo.df6917fd.svg";